import Box from "@mui/material/Box";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import NextLink from "next/link";
import { styled } from "@mui/material/styles";

/**
 * Our remixed version of MUI `Breadcrumbs`.
 */
export const Dreamcrumbs = ({
  links,
  currentTitle,
  ...propsToBreadcrumbs
}: React.ComponentProps<typeof Breadcrumbs> & {
  links?: {
    title: string;
    path: string;
  }[];
  currentTitle?: string;
}) => (
  <Breadcrumbs sx={{ mb: 2 }} separator={<Separator>&mdash;</Separator>} {...propsToBreadcrumbs}>
    {links?.map((link, idx) => (
      <NextLink key={idx} href={link.path} passHref legacyBehavior>
        <Link>{link.title}</Link>
      </NextLink>
    ))}
    {currentTitle && <Typography>{currentTitle}</Typography>}
  </Breadcrumbs>
);

const Separator = styled(Box)`
  padding-top: 0.1rem;
  font-size: 0.7rem;
  color: ${({ theme }) => theme.palette.primary.main};
`;
